import { useExperimentTreatment } from '@ms/yammer-experiments-context';
import { usePreloadComponent } from '@ms/yammer-libs-lazy';
import { LazyRelayModuleWrapper } from '@ms/yammer-relay/dist/environment';
import type { FC } from 'react';
import React, { useEffect } from 'react';

import {
  enableGlobalCopilot,
  prepareGlobalCopilotSession,
  resetGlobalCopilotHostMount,
  useHasGlobalCopilotOpened,
} from '../../store';
import { requestCatalystPrewarm, resetCatalystHostLifecycle } from '../../store/globalCopilot/catalystSDKStore';

import { LoadableGlobalCopilotDrawer, loadGlobalCopilotDrawer } from './LoadableGlobalCopilotDrawer';

enableGlobalCopilot();

export interface DeferredGlobalCopilotDrawerProps {
  readonly isFeedbackEnabled: boolean;
}

export const DeferredGlobalCopilotDrawer: FC<DeferredGlobalCopilotDrawerProps> = ({ isFeedbackEnabled }) => {
  usePreloadComponent(loadGlobalCopilotDrawer);

  const isCatalystEnabled = useExperimentTreatment('VivaEngageCatalystSDK');
  const hasOpened = useHasGlobalCopilotOpened();

  useEffect(() => {
    if (isCatalystEnabled) {
      prepareGlobalCopilotSession();
      requestCatalystPrewarm();
    }
  }, [isCatalystEnabled]);

  useEffect(
    () => () => {
      resetGlobalCopilotHostMount();
      resetCatalystHostLifecycle();
    },
    []
  );

  if (!isCatalystEnabled && !hasOpened) {
    return null;
  }

  return (
    <LazyRelayModuleWrapper>
      <LoadableGlobalCopilotDrawer isFeedbackEnabled={isFeedbackEnabled} />
    </LazyRelayModuleWrapper>
  );
};
